/* eslint-disable */

import { useMemo, useEffect, useState, useCallback } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
// import TrackChangesIcon from '@mui/icons-material/TrackChanges' // Commented out - Goal Planning not using now
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { get } from '../../http/restservice'
import { useLocation, useNavigate } from 'react-router-dom'
import env from '../../env/env'
import PlansCarousel from '../../Components/Home/PlansCarousel'
import DedicatedWealthTeam from '../../Components/Home/DedicatedWealthTeam'
import useMediaQuery from '../../hooks/useMediaQuery'
import { getUserDetails } from '../../utils/AuthUtil'

//SVGS to upload
import insurance from '../../assets/newHome/insurance.svg'
import taxPlanning from '../../assets/newHome/taxPlanning.svg'

import { useRecoilState, useRecoilValueLoadable } from 'recoil'
import { isDematUser } from '../../utils/AuthUtil'
import { Skeleton } from '../../Components/ui/skeleton'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'
import { HomeCarouselCards } from '../../store/HomePageStore'
import IntroVideo from '../FirstIdeas/IntroVideo'
import { UserKycStatus } from '../../store/UserStore'
import { userDetailsState } from '../LoginState'
import { MFUserBaskets } from '../../store/MFBasketsStore'
import { messageModalState } from '../../store/Feedback'
import { useSetRecoilState } from 'recoil'
import { StoriesFeed } from '../../Components/StoriesFeed/StoriesFeed'
import {
  cardMotionVariants as cardVariants,
  staggerContainerVariants as containerVariants,
} from '../../lib/motion'

const Card = ({ id, title, desc, gradient, icon: Icon, onClick, topCard, bottomCard }) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [isHovered, setIsHovered] = useState(false)
  const isFeature = Boolean(gradient)
  const isActionCenterCard = title === 'Action Plans'

  return (
    <motion.div
      className={`h-full ${isFeature ? 'fabits-card-strong' : 'fabits-card'}`}
      variants={cardVariants}
      initial='hidden'
      animate='visible'
      whileHover='hover'
      whileTap='tap'
      style={{
        boxShadow:
          isHovered && !isFeature
            ? '0 0 0 1px var(--fb-border-strong), var(--fb-shadow-md)'
            : undefined,
      }}
    >
      <div
        className={`relative flex-1 cursor-pointer overflow-hidden rounded-lg p-4 h-full ${
          isFeature ? 'min-h-[132px] lg:flex lg:flex-col lg:justify-center' : 'bg-white'
        } ${isFeature ? 'fabits-home-feature-pattern' : ''} ${
          isActionCenterCard ? 'fabits-home-action-center-card' : ''
        }`}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <motion.div
          className='relative flex justify-between items-start gap-3'
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1, duration: 0.2 }}
        >
          <h1
            className={`font-IBM text-[20px] font-bold leading-tight tracking-normal flex items-center gap-x-2 ${
              isFeature ? 'max-w-[72%] text-white lg:text-[30px]' : 'text-black-950'
            } ${topCard && !isFeature && 'lg:text-2xl'} ${
              bottomCard && '!text-[15px] lg:!text-xl'
            }`}
          >
            {Icon && (
              <motion.div
                initial={{ rotate: -180, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                transition={{ delay: 0.15, duration: 0.25 }}
              >
                <Icon className='h-6 w-6' />
              </motion.div>
            )}
            {title}
          </h1>
          {isDesktop && !isFeature && (
            <motion.div
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.2 }}
            >
              <ChevronRightIcon sx={{ color: '#656992' }} />
            </motion.div>
          )}
        </motion.div>
        {desc && (
          <motion.p
            className={`relative text-sm mt-3 font-normal leading-5 ${
              isFeature ? 'max-w-[82%] text-black-100' : 'text-black-600'
            } ${topCard ? 'lg:mt-4' : 'lg:mt-3'}`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.25 }}
          >
            {desc}
          </motion.p>
        )}
      </div>
    </motion.div>
  )
}

const NonKycUserHomePage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [userDetails] = useRecoilState(userDetailsState)

  const actionPlans = useRecoilValueLoadable(MFUserBaskets)
  const [isFICompleted, setIsFICompleted] = useState(false)
  const kycStatus = useRecoilValueLoadable(UserKycStatus)
  const carouselCards = useRecoilValueLoadable(HomeCarouselCards)
  const [showVideo, setShowVideo] = useState(location?.state?.hasSeenVideo)
  const [showDialog, setShowDialog] = useState(true)
  const [elogStatuses, setElogStatuses] = useState({})
  const [callKycAPIs, setCallKycAPIs] = useState(false)
  const setMessageModalState = useSetRecoilState(messageModalState)
  const [adminPlans, setAdminPlans] = useState([])
  const [showStoriesFeed, setShowStoriesFeed] = useState(false)

  let isUserFirstTime =
    location?.state?.firstTimeUser == true || location?.state?.hasSeenVideo === false

  useEffect(() => {
    const hasSeenVideo = localStorage.getItem('hasSeenVideo')

    if (!hasSeenVideo) {
      setShowVideo(true)
    }
  }, [])

  useEffect(() => {
    if (actionPlans?.state === 'hasValue' && Array.isArray(actionPlans?.contents?.data)) {
      const adminCuratedPlans = actionPlans?.contents?.data?.filter(
        (plan) =>
          plan.createdSource === 'ACTION PLAN' &&
          (plan?.sipStatus === 'PENDING' || plan?.oneTimeStatus === 'PENDING'),
      )

      setAdminPlans(adminCuratedPlans)
    }
  }, [actionPlans?.state, actionPlans?.contents?.data])

  useEffect(() => {
    const fetchKycNumber = async () => {
      // console.log(userDetails?.phoneNumber, 'userDetails?.phoneNumber')
      if (!userDetails?.phoneNumber) return

      // try {
      // const kycNumber = await fetchCustomerKycDetails(userDetails?.phoneNumber)

      // console.log(kycNumber, 'kycNumber')

      // if (kycNumber) {
      let elgStatus = await fetchCustomerKycStatuses(userDetails?.phoneNumber)
      console.log(elgStatus, 'elgStatus')
      if (elgStatus) {
        setElogStatuses(elgStatus)
      }
      // }
      // } catch (error) {
      //   console.error('Error fetching KYC details:', error)
      // }
    }

    fetchKycNumber()
  }, [userDetails])

  useEffect(() => {
    const initializeUserDetails = () => {
      if (userDetails?.phoneNumber) {
        isQuestionaireCompleted(userDetails?.phoneNumber)
      } else {
        isQuestionaireCompleted(getUserDetails()?.phoneNumber)
      }
    }

    initializeUserDetails()
  }, [])

  const isQuestionaireCompleted = useCallback(
    async (phoneNumber) => {
      const url = `${env.API_URL}customerservice/api/firstIdeas`

      try {
        const response = await get(url, {}, { phoneNumber })
        // console.log(response)
        setIsFICompleted(response?.isCompleted)
      } catch (error) {
        console.log(error)
      }
    },
    [userDetails?.phoneNumber],
  )

  // const fetchCustomerKycDetails = async (phNum) => {
  //   const phNo = '%2b91' + phNum?.replace(/^(\+91\s?)/, '')
  //   const response = await get(`${env.API_URL}customerservice/api/customer?phoneNumber=${phNo}`)

  //   console.log(response, 'response')
  //   if (!response || response?.isError) {
  //     return null
  //   }

  //   if (!response?.isError && response) {
  //     const kycPhone = response?.kycPhoneNumber
  //     return kycPhone
  //   }
  // }

  const fetchCustomerKycStatuses = async (phNum) => {
    const phNo = phNum?.replace(/^(\+91\s?)/, '')

    const response = await get(
      `${env.API_URL}customerservice/api/customer/fetchCustomerKycStatuses?kycPhoneNumber=${phNo}`,
    )

    console.log(response, 'response')

    if (response?.isError) {
      return null
    }

    if (!response?.isError) {
      return response
    }
  }

  const handleVideoEnd = () => {
    localStorage.setItem('hasSeenVideo', 'true')
    setShowVideo(false)
    setShowDialog(false)
  }

  // Static cards that don't change (excluding performance card which is now in top row)
  const staticCardsBottom = [
    {
      id: 3,
      title: (
        <div className='flex m-2 gap-x-[10px] items-center'>
          <img
            className='fabits-icon-on-dark'
            src={`${env.S3_BASE_URL}/firstTime/analytics.svg`}
            height={32}
            width={32}
            alt='Analytics'
          />
          <p className='flex items-center gap-2'>2025 Performance</p>
        </div>
      ),
      desc: 'Fabits has outperformed its benchmarks with lower volatility',
      navigateTo: () => setShowStoriesFeed(true),
    },
    {
      id: 4,
      title: (
        <div className='flex m-2 gap-x-[10px] items-center'>
          <img
            className='fabits-icon-on-dark'
            src={insurance || '/placeholder.svg'}
            height={32}
            width={32}
            alt='Insurance'
          />
          <p>Insurance</p>
        </div>
      ),
      desc: 'Identify coverage gaps with policy reviews',
      navigateTo: () => navigate('/dashboard/insurance'),
    },
    {
      id: 5,
      title: (
        <div className='flex m-2 gap-x-[10px] items-center'>
          <img
            className='fabits-icon-on-dark'
            src={taxPlanning || '/placeholder.svg'}
            height={32}
            width={32}
            alt='Tax Planning'
          />
          <p>Tax Planning</p>
        </div>
      ),
      desc: 'Personalised tax planning to maximise deductions and savings',
      navigateTo: () => navigate('/dashboard/tax-filing'),
    },
  ]

  const isElogPending = elogStatuses?.uccRegistered && !elogStatuses?.elogDone

  const hasActionPlans =
    actionPlans?.state === 'hasValue' &&
    actionPlans?.contents?.data?.length > 0 &&
    adminPlans?.length > 0 &&
    isFICompleted

  const isCuratingPlans = isFICompleted && !actionPlans?.contents?.data?.length

  // Card 1 (KYC / Elog / Curating)
  const mainCard1 = {
    id: 1,
    title: isElogPending ? 'You’re almost there! 🚀' : 'Complete your KYC',

    desc: isElogPending
      ? 'Just one final step to activate your account and continue investing.'
      : 'Just a few steps to start wealth building.',

    navigateTo: isElogPending
      ? () =>
          navigate('/dashboard/start-kyc', {
            state: { isElogDone: false },
          })
      : () => navigate('/dashboard/start-kyc'),
  }

  // Card 2 (Action Center / Ready State)
  const mainCard2 = {
    id: 2,
    title:
      isFICompleted && !hasActionPlans
        ? 'Curating your plans...'
        : (isFICompleted && hasActionPlans) || (!isFICompleted && hasActionPlans)
        ? 'Action Plans'
        : 'Start here',
    desc:
      isFICompleted && !hasActionPlans ? (
        'We will get in touch with you soon'
      ) : (isFICompleted && hasActionPlans) || (!isFICompleted && hasActionPlans) ? (
        <>
          <span className='fabits-marker'>Proceed</span> with your plans
        </>
      ) : (
        'Build your financial plan'
      ),
    navigateTo:
      isFICompleted && !hasActionPlans
        ? () => navigate('/dashboard')
        : (isFICompleted && hasActionPlans) || (!isFICompleted && hasActionPlans)
        ? () => navigate('/dashboard/firstTime/actionPlanUser')
        : () => navigate('/dashboard/firstTime/questionnaire'),
  }

  const topMainCards = [mainCard1, mainCard2]

  return (
    <>
      {showStoriesFeed && <StoriesFeed autoOpen={true} onClose={() => setShowStoriesFeed(false)} />}

      <motion.div
        className='fabits-page min-h-screen px-4 lg:px-0 py-4 flex flex-col gap-4 lg:mx-auto lg:max-w-[1128px]'
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
      >
        <AnimatePresence>
          {!isDematUser() && (
            <motion.div
              className='mb-5'
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.1, duration: 0.3 }}
              exit={{ opacity: 0, x: -20 }}
            >
              {!elogStatuses?.uccRegistered && !elogStatuses?.elogDone && (
                <motion.h1
                  className='font-IBM font-bold text-[28px] leading-[1.06] tracking-normal text-black-950'
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2, duration: 0.25 }}
                >
                  Welcome to <span className='fabits-marker'>Fabits</span>
                </motion.h1>
              )}

              {/* {!elogStatuses?.uccRegistered && !elogStatuses?.elogDone && <motion.p
                className='font-DMSans font-normal text-base text-primary-600 mt-3 flex items-center gap-2 cursor-pointer'
                onClick={() => navigate('/dashboard/start-kyc')}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.25 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}

              >
                Complete KYC details <ArrowOutwardIcon className='h-6 w-6' />
              </motion.p>} */}
              {kycStatus?.state === 'hasValue' &&
                kycStatus?.contents &&
                kycStatus?.contents?.status === 'success' &&
                kycStatus?.contents?.applicationStatus === 'needs_review' && (
                  <motion.p
                    className='font-DMSans font-normal text-base text-primary-600 mt-3 flex items-center gap-2 cursor-pointer'
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.25 }}
                  >
                    KYC under review
                  </motion.p>
                )}
            </motion.div>
          )}
        </AnimatePresence>

        <motion.div
          className={`flex flex-col lg:flex-row gap-4 lg:max-w-[1128px]`}
          variants={containerVariants}
          initial='hidden'
          animate='visible'
        >
          <div className={`flex-1 flex md:flex-row flex-col gap-4`}>
            <AnimatePresence>
              {topMainCards.map((card, index) => (
                <motion.div
                  className={`flex-[1] lg:h-[150px]`}
                  key={card.id}
                  variants={cardVariants}
                  layout
                >
                  <Card
                    topCard={index === 0 || index === 1}
                    gradient={index === 0 || index === 1}
                    {...card}
                    onClick={card.navigateTo}
                  />
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </motion.div>

        <motion.div
          className='lg:flex gap-4 lg:max-w-[1128px]'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.3 }}
        >
          <>
            <motion.div
              className='space-y-4 lg:space-y-0 lg:grid lg:grid-cols-3 gap-4'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.25 }}
            >
              {staticCardsBottom.map((card, index) => (
                <motion.div
                  key={card.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6 + index * 0.05, duration: 0.25 }}
                >
                  <Card bottomCard {...card} onClick={card.navigateTo} />
                </motion.div>
              ))}
            </motion.div>
          </>
        </motion.div>

        {/* Dedicated Wealth Team section */}
        <DedicatedWealthTeam />

        <AnimatePresence mode='wait'>
          {carouselCards.state === 'hasValue' && carouselCards.state !== 'hasError' ? (
            <motion.div
              className='lg:max-w-[1128px] mt-10'
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.3 }}
              exit={{ opacity: 0, y: -30 }}
            >
              <motion.h1
                className='font-semibold text-lg'
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.9, duration: 0.25 }}
              >
                Understand your Money
              </motion.h1>

              <motion.div
                className='flex flex-col gap-y-5 mt-6'
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.0, duration: 0.25 }}
              >
                <PlansCarousel newPage contentCarouselData={carouselCards.contents} />
              </motion.div>
            </motion.div>
          ) : (
            <motion.div
              className='mb-6'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.25 }}
              exit={{ opacity: 0 }}
            >
              {/* Understand your money section */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9, duration: 0.25 }}
              >
                <Skeleton className='h-8 w-30 lg:w-64 mb-6' />
                <div className='flex gap-x-6 justify-between overflow-x-hidden'>
                  <Skeleton className='h-48 w-full rounded-xl' />
                  <Skeleton className='hidden md:block h-48 w-full rounded-xl' />
                  <Skeleton className='hidden lg:block h-48 w-full rounded-xl' />
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>

      <AnimatePresence>
        {isUserFirstTime && showVideo && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <IntroVideo
              showDialog={showDialog}
              setShowDialog={setShowDialog}
              handleVideoEnd={handleVideoEnd}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default NonKycUserHomePage
